// extracted by mini-css-extract-plugin
module.exports = {"Album":"Album_Album__Vdd8a","hide":"Album_hide__1KNPM","show":"Album_show__2V_zf","lightbox":"Album_lightbox__3b7PC"};